/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/**
 * @author Juan Carlos Cancela <cancela.juancarlos@gmail.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import { connect } from 'react-redux';
import { get } from 'lodash';
import s from './Layout.css';
import Header from '../Header';
import LeftNavigation from '../LeftNavigation';
import Footer from '../Footer';
import Loading from '../Loading/Loading';
import LoadingIndicator from '../LoadingIndicator';
import * as AuthActions from '../../actions/authActions';
import ImageBanner from '../../../public/images/banner.png';
import { LOCALSTORAGE_AUTH_KEY } from '../../constants';
import ModalHorarios from '../../../src/components/Telemedicina/ModalHorarios/ModalHorarios'

class Layout extends React.Component {
  static defaultProps = {
    wait: false,
    hideLayout: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      hideLayout: props.hideLayout,
    };
  }

  componentDidMount() {
    // Para que funcione en el iframe del dashboard la web react
    if (!this.state.hideLayout) return;

    this.initHeightMessageInterval();
    const auth = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
    if (auth) {
      this.props.authSuccess(JSON.parse(auth), true);
    }
  }

  initHeightMessageInterval = () => {
    // Notifica a la web de react el alto del contenido para actualizar el height del iframe
    setInterval(() => {
      const app = document.getElementById('app');
      const data = JSON.stringify({
        type: 'HEIGHT_UPDATE',
        data: app.scrollHeight,
      });
      window.top.postMessage(data, '*');
    }, 500);
  };

  renderBanner = () => (
    <div
      className={`${s.imageBanner} col-md-12`}
      style={{ backgroundImage: `url(${ImageBanner})` }}
    >
      <h1>
        <div className={`${s.eConsultaDiv}`}>
          <span className={`${s.eConsulta}`}>E-Consulta</span>
        </div>
        <div>
          <small>Tu médico en línea</small>
        </div>
      </h1>
    </div>
  );

  renderIframeContent = () => {
    const { auth, children } = this.props;

    const isAuth = get(auth, 'loginResponse.token');

    return isAuth ? (
      children
    ) : (
      <div style={{ paddingTop: 50 }}>
        <LoadingIndicator />
      </div>
    );
  };

  render() {
    const { hideLayout } = this.state;
    const { auth, wait, children } = this.props;

    if (hideLayout) return this.renderIframeContent();

    const isAuth = get(auth, 'loginResponse.token');
    return (
      <div>
        {wait ? <Loading /> : null}
        <div>
          <Header />
          <LeftNavigation />
          <ModalHorarios/>
          {isAuth && this.renderBanner()}
          {children}
          <Footer />
        </div>
      </div>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  wait: PropTypes.bool.isRequired,
  auth: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = state => ({
  wait: state.loading.wait,
  auth: state.auth,
});

export default connect(
  mapStateToProps,
  AuthActions,
)(withStyles(normalizeCss, s)(Layout));



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js